import {SubmissionState} from "./SubmissionState";

export class FormPagesState extends SubmissionState{

    page: number;
    appData: any;
    invalidPages: Array<number>;
    saving: boolean;
    saveModalOpen: boolean;
    saveEmailAddress: string;
    saveEmailAddressErrorMessage: string;
    saveEmailSubject: string;
    saveEmailSubjectErrorMessage: string;
    draftSubmissionId: string;
    copySuccess: string;
    savedStateAppUrl: string;
    amountToPay: string;

    constructor(page: number,
                appData: any,
                saveEmailSubject: string,
                invalidPages: Array<number> = [],
                saving: boolean = false,
                saveModalOpen: boolean = false,
                saveEmailAddress: string = "",
                saveEmailAddressErrorMessage: string = "",
                saveEmailSubjectErrorMessage: string = "",
                draftSubmissionId: string = "",
                copySuccess: string = 'Copy',
                savedStateAppUrl: string = "",
                amountToPay: string = "0.00") {
        super();
        this.page = page;
        this.appData = appData;
        this.saveEmailSubject = saveEmailSubject;
        this.invalidPages = invalidPages;
        this.saving = saving;
        this.saveModalOpen = saveModalOpen;
        this.saveEmailAddress = saveEmailAddress;
        this.saveEmailAddressErrorMessage = saveEmailAddressErrorMessage;
        this.saveEmailSubjectErrorMessage = saveEmailSubjectErrorMessage;
        this.draftSubmissionId = draftSubmissionId;
        this.copySuccess = copySuccess;
        this.savedStateAppUrl = savedStateAppUrl;
        this.amountToPay = amountToPay;
    }

}